import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';

/**
 * 댓글 신고
 *
 * Origin: pageNicolasApi.declareComment
 * API: POST /api/v5/store/community/declare
 */
export async function postStoreCommunityDeclare(
  declareCommentInput: {
    commentUid: number;
    declareType: string;
    declareComment?: string | null;
  },
  options?: FetcherOptions
): Promise<
  ApiResultVo & {
    /** 불법촬영물유통신고(H)인 경우 전달 */ landing_url?: string;
  }
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/declare',
    {
      method: 'POST',
      data: trimUndefinedFromObject({
        commentuid: declareCommentInput.commentUid,
        declaretype: declareCommentInput.declareType,
        declarecomment: declareCommentInput.declareComment,
      }),
    },
    options
  );
  return response.data;
}
